import { Users, MessageCircleCheck, MessageCircleQuestionMark } from 'lucide-react'
import type { ConversationStats } from '@/api/feedback-conversation.api'


interface Props {
    stats?: ConversationStats
}

export function ConversationStatsCards({ stats }: Props) {
    const items = [
        {
            icon: <Users className="h-5 w-5 text-[#03A6EB]" />,
            label: 'Lượt tiếp đón',
            value: stats?.totalSession ?? 0,
            color: 'border-[#03A6EB]',
        },
        {
            icon: <MessageCircleCheck className="h-5 w-5 text-[#16A249]" />,
            label: 'Tỷ lệ phản hồi thành công',
            value: stats?.totalSuccess ?? 0,
            color: 'border-[#00AD51]',
        },
        {
            icon: <MessageCircleQuestionMark className="h-5 w-5 text-[#DD2A2D]" />,
            label: 'Nội dung chưa thể phản hồi',
            value: stats?.totalFail ?? 0,
            color: 'border-[#E44346]',
        },
    ]

    return (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
            {items.map((item, i) => (
                <div
                    key={i}
                    className={`flex flex-col justify-between rounded-xl border border-solid ${item.color} bg-white p-4 shadow-sm transition-all hover:shadow-md`}
                >
                    <div className="mb-2 flex items-center gap-1.5 text-sm font-medium text-[#757575]">
                        {item.icon}
                        <span className="truncate">{item.label}</span>
                    </div>
                    <div className="text-2xl font-bold text-[#1E2F41]">{item.value}</div>
                </div>
            ))}
        </div>
    )
}